import { IoSearchCircleSharp } from "react-icons/io5";
export const navbarData = [
    {
        id: 1,
        value: "Anywhere",
        img: null
    },
    {
        id: 2,
        value: "Any week",
        img: null
    },
    {
        id: 3,
        value: "Add guests",
        img: <IoSearchCircleSharp size={40} color="#ff385c"/>
    }
]